import { Product, Project } from '../../../store/store.types'
import { get } from '../../../utils/api'
import { locations } from '../../../utils/locations'

export interface TrainingUuid {
  id: number
  product: Product
  project: Project
  executionUuid: string
}

interface Data {
  results: TrainingUuid[]
}

const fetchTrainings = (executionUuid: string) =>
  get<Data>(locations.trainingsUuid(executionUuid))
    .then((data) => {
      if (data.results.length > 0) {
        return data.results
      }
      return undefined
    })
    .catch(() => undefined)

export { fetchTrainings }
